import { useMemo } from 'react';
import {MenuSection} from "../@types/stores/menu";
import menuStore from "../stores/menu";
import {subCategoryHasHalfAndHalf} from "../helpers/ApiHelper";


export const useHasHalfAndHalf = (subCategory: MenuSection) => {
    return useMemo(() => {
        return subCategoryHasHalfAndHalf(subCategory);
    }, [subCategory, menuStore.menu]);
};

export default useHasHalfAndHalf;
